export const getProtocolVersion = () => parseInt(process.env.PROTOCOL_VERSION || '0');
export const getCommitHash = () => process.env.COMMIT_SHA || 'none';
